module.exports = __webpack_public_path__ + "static/taxigy-7e36f3f619ae722c7195833442f5abbf.png";